import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MUIFormHelperText(theme: Theme): Components['MuiFormHelperText'] {
  return {
    styleOverrides: {
      root: {
        margin: 0,
        paddingLeft: theme.spacing(3),
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
      },
    },
  };
}
